

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action, Mutation } from "vuex-class"

import vSelect from "vue-select"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import { BModal } from "bootstrap-vue"

import SkeletonLoader from "@/components/SkeletonLoader.vue"

import api from "@/services/api"
const caseStore = namespace("cases")

@Component({
	components: {
		"loader": SkeletonLoader
	}
})
export default class CaseFilePreview extends Vue {
	$refs!: {
		previewModal: BModal;
		image: HTMLImageElement;
	}

	@caseStore.Getter("getPreviewFile")
	public previewFile: any;

	public imageLoaded: boolean = false;

	@caseStore.Mutation
	public setPreviewFile!: (file: any) => void;

	mounted () {
		this.setPreviewFile(null)
	}

	beforeDestroy () {
		this.setPreviewFile(null)
	}

	@Watch("previewFile")
	onPreviewFileChanged (newValue: any) {
		if (newValue) {
			this.imageLoaded = false
			this.$refs.previewModal.show()
		} else {
			this.$refs.previewModal.hide()
		}
	}

	private get isVideo (): boolean {
		if (!this.previewFile) {
			return false
		}

		const filename = this.previewFile.filename
		const extension = filename.substring(filename.lastIndexOf(".") + 1).toLowerCase()

		return (extension === "mp4" || extension === "mov")
	}

	private get thumbnailImagePath (): string {
		if (!this.previewFile) {
			return ""
		}

		return api.baseUrl + "files/download/" + this.previewFile.id + "?thumbnail=true"
	}

	private get imagePath (): string {
		if (!this.previewFile) {
			return ""
		}

		return api.baseUrl + "files/download/" + this.previewFile.id
	}

	public downloadFile () {
		let downloadUrl = api.baseUrl + "files/download/" + this.previewFile.id

		let link = document.createElement("a")
		link.href = downloadUrl
		link.download = downloadUrl
		link.click()
	}

	onImageLoaded () {
		this.imageLoaded = true
	}
}
